<template>
	<tr class="tableTr">
		<td class="dense" :class="{'tdGreen': checkClasses['filter_create_date']}">{{ item.date }}</td>
		<td class="dense" :class="{'tdGreen': checkClasses['filter_created_by']}">{{ item.created_by }}</td>
		<td :class="{'tdGreen': checkClasses['filter_description']}">
			<field
					margin="0"
					input-text-style="4"
					width="100%"
					placeholder="Cell"
					:setInputValue="item.msg"
					:idx="idx"
					@updateInput="onRepair"
					is-off-style
			></field>
		</td>
		<td width="40">
			<button
					class="deleteIcon"
					type="button"
					@click="onDeleteItem(idx, id)"
					:disabled="!permissions[9]"
			>
				<svg-sprite :style="`color: ${permissions[9] ? '#19bc38': '#8f90a6'}`" height="20" width="20" icon-id="deleteItem"></svg-sprite>
			</button>
		</td>
	</tr>
</template>

<script>

import { mapActions } from "vuex";

export default {
	name: "TableTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		id: Number,
		isDelItem: Boolean,
		idx: Number
	},
	methods: {
		...mapActions([ 'getWorkOrdersDelete' ]),
		onRepair(values) {
			values.id = this.id;
			this.$emit('updateRepair', values);
		},
		onDeleteItem(idx, id) {
			if (id) this.getWorkOrdersDelete({ id });
			this.$emit('updateDeleteItem', idx);
		}
	}
};
</script>

<!--<style lang="scss" scoped>-->
<!--.disabled {-->
<!--	opacity: .6;-->
<!--	cursor: default;-->
<!--}-->

<!--.deleteIcon[disabled] {-->
<!--	pointer-events: none;-->
<!--}-->

<!--.dense {-->
<!--	padding: 0 5px !important;-->
<!--}-->

<!--tr {-->
<!--	background: #2B2B37;-->

<!--	td {-->
<!--		font-weight: 400;-->
<!--		font-size: 14px;-->
<!--		line-height: 20px;-->
<!--		color: #FFFFFF;-->
<!--		border-right: 1px solid rgba(255, 255, 255, 0.2);-->
<!--		border-bottom: 1px solid rgba(255, 255, 255, 0.2);-->
<!--		white-space: nowrap;-->

<!--		&.center {-->
<!--			text-align: center;-->
<!--			vertical-align: inherit;-->
<!--		}-->
<!--	}-->

<!--	td:last-child {-->
<!--		border-right: none;-->
<!--	}-->
<!--}-->
<!--</style>-->

<!--<style lang="scss">-->
<!--.center {-->
<!--	text-align: center;-->
<!--}-->

<!--.descN {-->
<!--	background: linear-gradient(90deg, rgba(7, 126, 30, 0.75) 1.79%, rgba(25, 188, 56, 0.75) 98.81%);-->
<!--	border-radius: 4px;-->
<!--	font-weight: 500;-->
<!--	font-size: 12px;-->
<!--	line-height: 16px;-->
<!--	display: inline-flex;-->
<!--	justify-content: center;-->
<!--	align-items: center;-->
<!--	text-align: center;-->
<!--	letter-spacing: 0.25px;-->
<!--	color: #FFFFFF;-->
<!--	width: 24px;-->
<!--	height: 24px;-->
<!--	cursor: help;-->
<!--}-->
<!--.tableTr {-->
<!--	.status {-->
<!--		display: flex;-->
<!--		align-items: center;-->

<!--		&_color {-->
<!--			flex: 0 0 4px;-->
<!--			width: 4px;-->
<!--			height: 16px;-->
<!--			display: inline-block;-->
<!--			margin-right: 10px;-->
<!--		}-->
<!--	}-->
<!--}-->

<!--.tdGreen {-->
<!--	background: #71cc824d;-->
<!--}-->

<!--.icons {-->
<!--	display: grid;-->
<!--	grid-template-columns: 25px 25px 25px 25px;-->
<!--	grid-gap: 5px;-->
<!--}-->

<!--.tableTr td {-->
<!--	height: 40px !important;-->
<!--}-->

<!--.infoTable {-->
<!--	tr:nth-of-type(1) td {-->
<!--		border-top: .5px solid #19bc3880;-->
<!--	}-->
<!--}-->
<!--</style>-->
